import { render } from "./subagent.vue?vue&type=template&id=bbe12d78&scoped=true"
import script from "./subagent.vue?vue&type=script&lang=js"
export * from "./subagent.vue?vue&type=script&lang=js"

import "./subagent.vue?vue&type=style&index=0&id=bbe12d78&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bbe12d78"

export default script